import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";

export const CREATE_INVENTORY_BASKET =
  "inventoryManagement/CREATE_INVENTORY_BASKET";
export const UPDATE_INVENTORY_BASKET =
  "inventoryManagement/UPDATE_INVENTORY_BASKET";
export const DELETE_INVENTORY_BASKET =
  "inventoryManagement/DELETE_INVENTORY_BASKET";
export const RETRIEVE_INVENTORY_BASKETS =
  "inventoryManagement/RETRIEVE_INVENTORY_BASKETS";

const CREATE_INVENTORY_BASKET_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_INVENTORY_BASKET_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_INVENTORY_BASKET_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_INVENTORY_BASKET_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const INVENTORY_MANAGEMENT_BASKET_CONTEXT = "inventory_management_proj";

const initialState = {
  inventoryBaskets: {},
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_INVENTORY_BASKET: {
        break;
      }

      case RETRIEVE_INVENTORY_BASKETS: {
        draft.inventoryBaskets[action.groupId] = {};

        action.inventoryBaskets.forEach((i) => {
          draft.inventoryBaskets[action.groupId][i.group_project_id] = i;
        });
        break;
      }

      case UPDATE_INVENTORY_BASKET: {
        break;
      }

      case DELETE_INVENTORY_BASKET: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const createInventoryBasket = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "inventory_management.createInventoryBasket",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = INVENTORY_MANAGEMENT_BASKET_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_CREATE_GROUP_PROJECT,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_INVENTORY_BASKET });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "inventory_management.createInventoryBasket",
                },
            history
          )
        );
        dispatch(
          retrieveInventoryBaskets({
            values,
            successState: {
              context:
                "inventory_management.createInventoryBasket.retrieveInventoryBaskets",
            },
            errorState: (error) => ({
              ...error,
              context:
                "inventory_management.createInventoryBasket.retrieveInventoryBaskets",
              notificationType: "alert",
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_INVENTORY_BASKET_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "inventory_management.createInventoryBasket",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveInventoryBaskets = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "inventory_management.retrieveInventoryBaskets",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = INVENTORY_MANAGEMENT_BASKET_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_RETRIEVE_GROUP_PROJECTS,
        values
      )
      .then((response) => {
        const inventoryBaskets = _.get(response, "data.group_projects", []);
        const groupId = _.get(values, "group_id");

        dispatch({
          type: RETRIEVE_INVENTORY_BASKETS,
          inventoryBaskets,
          groupId,
        });

        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "inventory_management.retrieveInventoryBaskets",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_INVENTORY_BASKET_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "inventory_management.retrieveInventoryBaskets",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateInventoryBasket = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "inventory_management.updateInventoryBasket",
        }
      )
    );

    values.context = INVENTORY_MANAGEMENT_BASKET_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_UPDATE_GROUP_PROJECT,
        values
      )
      .then((response) => {
        const inventoryBasket = _.get(response, "data.group_project");
        const groupId = _.get(values, "group_id");

        dispatch({ type: UPDATE_INVENTORY_BASKET, inventoryBasket, groupId });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "inventory_management.updateInventoryBasket",
                },
            history
          )
        );
        dispatch(
          retrieveInventoryBaskets({
            values,
            successState: {
              context:
                "inventory_management.updateInventoryBasket.retrieveInventoryBaskets",
            },
            errorState: (error) => ({
              ...error,
              context:
                "inventory_management.updateInventoryBasket.retrieveInventoryBaskets",
              notificationType: "alert",
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_INVENTORY_BASKET_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "inventory_management.updateInventoryBasket",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteInventoryBasket = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          notificationType: "inventory_management.deleteInventoryBasket",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_DELETE_GROUP_PROJECT,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_INVENTORY_BASKET });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "inventory_management.deleteInventoryBasket",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_INVENTORY_BASKET_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "inventory_management.deleteInventoryBasket",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
